const Room = () => ({
  awardedAt: null,
  chId: null,
  createdAt: null,
  creator: null,
  creatorName: null,
  curPrize: null,
  endedAt: null,
  id: null,
  name: null,
  photoURL: null,
  prize: null,
  prizeRatio: null,
  startedAt: null,
  quizIndex: null,
  publishedQuizIndex: null,
  quizTimeLimit: null,
  status: null,
  quizStatus: null,
  totalWatchers: null,
  fps: null
})

export default Room
